//import '../../scss/layouts/trust-radius-widget.scss'

export default () => {
	function findMaxHeight() {
		let maxHeight = 0;
		jQuery(".tr-card").each(function () {
			if (jQuery(this).height() > maxHeight) {
				maxHeight = jQuery(this).height();
			}
		});
		jQuery(".tr-reviews-viewport").css('min-height', maxHeight + 1);
	}

	const targetNode = document.getElementById('dr-tqw');

	let trObserver = new MutationObserver(findMaxHeight);

	trObserver.observe(targetNode, {childList: true, subtree: true});

	window.onresize = function () {
		findMaxHeight();
	}

	let script = document.createElement("script");
	script.src = 'https://www.trustradius.com/trustquotes/trustquotes.js';
	script.async = true;
	document.body.appendChild(script);
}
